module.exports = __webpack_public_path__ + "img/aws.b5f2b5c1.png";